export default "__VITE_ASSET__CENwut$e__"